import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { NavigationProgressComponent } from './components/navigation-progress/navigation-progress.component';
import { LogoutOverlayComponent } from './core/authentication/logout-overlay.component';
import { DEEP_LINK_CONFIG } from './shared/config/deep-link.config';
import { DeepLinkService } from './shared/services/deep-link/deep-link.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [CommonModule, IonApp, IonRouterOutlet, LogoutOverlayComponent, NavigationProgressComponent],
})
export class AppComponent {
  private readonly deepLinkService = inject(DeepLinkService);

  constructor() {
    // Initialize deep link handling with configuration
    this.deepLinkService.initialize(DEEP_LINK_CONFIG);
  }
}
